// redux/selectors/ugc/prayerSelectors.ts

import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../storeTypes";
import type { PrayerDTO } from "../../../types/ugc/prayerTypes";

const selectPrayerState = (state: RootState) => state.prayers;
const selectBySlugMap = (state: RootState) => state.prayers.bySlug;

export const selectPrayerBySlug = (slug?: string) =>
  createSelector(
    [selectBySlugMap],
    (bySlug): PrayerDTO | undefined =>
      slug ? bySlug[slug] : undefined
  );

export const selectPrayerFeed = createSelector(
  [selectPrayerState, selectBySlugMap],
  (state, bySlug): PrayerDTO[] =>
    state.feed.ids.map((slug) => bySlug[slug]).filter(Boolean)
);

export const selectPrayerExplore = createSelector(
  [selectPrayerState, selectBySlugMap],
  (state, bySlug): PrayerDTO[] =>
    state.explore.ids.map((slug) => bySlug[slug]).filter(Boolean)
);

export const selectMyPrayers = createSelector(
  [selectPrayerState, selectBySlugMap],
  (state, bySlug): PrayerDTO[] =>
    state.me.ids.map((slug) => bySlug[slug]).filter(Boolean)
);

// ------------------------------------------------------------
// Derived lifecycle selectors
// ------------------------------------------------------------
export const selectPrayerIsAnswered = (slug: string) =>
  createSelector([selectBySlugMap], (bySlug) =>
    bySlug[slug]?.status === "answered"
  );

export const selectPrayerIsWaiting = (slug: string) =>
  createSelector([selectBySlugMap], (bySlug) =>
    bySlug[slug]?.status === "waiting"
  );

export const selectPrayerHasResponse = (slug: string) =>
  createSelector([selectBySlugMap], (bySlug) =>
    Boolean(bySlug[slug]?.response)
  );


// ------------------------------------------------------------
// Operation Status Selectors
// ------------------------------------------------------------

export const selectPrayerCreateStatus = (state: RootState) =>
  state.prayers.createStatus;

export const selectPrayerDeleteStatus = (state: RootState) =>
  state.prayers.deleteStatus;

export const selectPrayerUpdateStatus = (state: RootState) =>
  state.prayers.updateStatus;

export const selectPrayerResponseStatus = (state: RootState) =>
  state.prayers.responseStatus;

export const selectPrayerOpError = (state: RootState) =>
  state.prayers.opError;